import { makePublishHelper, makeSubscribeHelper } from '../../helpers-creators';

var schema = {};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  schema = require('../schemas/item-data.schema.json');
}

export var commandSelect = makePublishHelper('commandSelect', 'wh.common.command.ui.header.sub-menu-start.select', schema);

export var onCommandSelect = makeSubscribeHelper('onCommandSelect', 'wh.common.command.ui.header.sub-menu-start.select', schema);
//# sourceMappingURL=commandSelect.js.map